import { render, staticRenderFns } from "./Freezer_request.vue?vue&type=template&id=3af91ea9&"
import script from "./Freezer_request.vue?vue&type=script&lang=js&"
export * from "./Freezer_request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports